import { array, mixed, number, object, string } from 'yup';
import { Profession } from './profession.enum';
import { Pack } from './packs';
import { RegistrationType } from './registration.enum';
import { RegistrationStatus } from './status.enum';
import { RegistrationPass } from './registration.dto';

const participantsSchema = array()
  .of(
    object({
      firstName: string().required(),
      familyName: string().required(),
      profession: mixed<Profession>().required(),
      speciality: string().required(),
      phoneNumber: string().required(),
      email: string().required(),
      city: string().required(),
      country: string().required(),
      pack: mixed<Pack>().required(),
      roommate: number().optional(),
    }),
  )
  .min(1);

export const createRegistSchema = object({
  technicalId: string().optional(),
  representative: object({
    fullName: string(),
    role: string(),
    phoneNumber: string(),
    email: string(),
  }).notRequired(),
  participants: participantsSchema,
  company: object({
    name: string(),
    ice: string(),
    address: string(),
    city: string(),
    country: string(),
  }).notRequired(),
  comment: string().optional().max(300),
  type: mixed<RegistrationType>().required(),
  pass: mixed<RegistrationPass>().optional(),
});

export const registrationValidationSchema = object({
  technicalId: string().uuid().required(),
  status: mixed<RegistrationStatus>().required(),
  participants: participantsSchema,
});

export const reservIdSchema = object({
  id: string().uuid().required(),
});

export const badgeSchema = object({
  id: string().uuid().required(),
  email: string().email().required(),
});
